exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userSearchForm__form___1hLBC {\n  padding: 8px 12px;\n  border-left: 1px solid #e8e8e8;\n  border-right: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n  width: 100%; }\n\n.userSearchForm__userSearchFormActionButton___2ytvC {\n  height: 54px;\n  width: 100% !important; }\n\n.userSearchForm__gutterBox___Db7nN {\n  padding-left: 2.5px;\n  padding-right: 2.5px;\n  margin-bottom: 10px; }\n", ""]);

// exports
exports.locals = {
	"form": "userSearchForm__form___1hLBC",
	"userSearchFormActionButton": "userSearchForm__userSearchFormActionButton___2ytvC",
	"gutterBox": "userSearchForm__gutterBox___Db7nN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/UserSearchForm/userSearchForm.scss
// module id = 1938
// module chunks = 6